import { Form } from 'antd';
import { AppFormBase, AppBodyRow, AppBodyRowProps } from 'components/atoms';
import { DailyAttendanceEditableRowFormFields } from 'types';

export const DailyAttendanceEditableRow = ({ ...props }: AppBodyRowProps) => {
    const [form] = Form.useForm<DailyAttendanceEditableRowFormFields>();

    return (
        <AppFormBase name="dailyAttendanceEdit" form={form} component={false}>
            <AppBodyRow {...props} />
        </AppFormBase>
    );
};
